var UiBlock = window.UiBlock = (function() {
    function unBlock(uiBlock) {
        $(uiBlock.selector == '_window' ? window : uiBlock.selector).unblock();
    }

    var blockTypes =
        {
            default: {
                css: {
                    zIndex: 1011,
                    position: 'fixed',
                    padding: 0,
                    margin: 0,
                    width: '100%',
                    top: 0,
                    left: 0,
                    textAlign: 'left',
                    color: 'rgb(0, 0, 0)',
                    border: 'none',
                    backgroundColor: 'transparent',
                    cursor: 'default',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                themedCSS: {
                    width: '30%',
                    top: '30%',
                    left: '35%'
                },
                overlayCSS: {
                    borderRadius: '0px'
                }
            },
            transparent: { css: { border: 'none', 'background-color': 'transparent' } },
            '680px': { css: { width: '36%', left: '32%' } }
        };

    function block(uiBlock) {
        var block = $.extend(true, {}, uiBlock);
        delete block.messageSelector;
        delete block.message;

        if (uiBlock.message) {
            block.message = uiBlock.message;
        }
        if (uiBlock.messageSelector) {
            block.message = $(uiBlock.messageSelector).clone().wrap('<p>').parent().html();
        }

        var blckConfig: any = {};
        $.extend(true, blckConfig, blockTypes.default);

        if (block.type)
        {
            $.extend(true, blckConfig, blockTypes[block.type] || {});

            block.type = null;
        }

        $.extend(true, blckConfig, block);

        if (blckConfig.overlayCSS && blckConfig.overlayCSS.position) {
            blckConfig.overlayCSS.userOverlayCSSPosition = true;
        }

        $(uiBlock.selector == '_window' ? window : uiBlock.selector).block(blckConfig);
    }

    function getUiBlockPropertyName(attrName: string, level: number) {
        if (level == 0 && attrName.toLowerCase() == 'overlaycss') {
            return 'overlayCSS';
        }
        if (level == 0 && attrName.toLowerCase() == 'blockmsgclass') {
            return 'blockMsgClass';
        }

        if (level == 0 && attrName.toLowerCase() == 'centerx') {
            return 'centerX';
        }

        if (level == 0 && attrName.toLowerCase() == 'centery') {
            return 'centerY';
        }

        if (level == 0 && attrName.toLowerCase() == 'messageselector') {
            return 'messageSelector';
        }
        if (attrName.toLocaleLowerCase() == 'backgroundcolor')
        {
            return 'background-color';
        }

        return attrName;
    }

    function getDefaultSpinnerBlock(element: HTMLElement, defaultValue: any = undefined ) {
        var blockSelector: string = '_window';
        if (Popup.isInPopup(element)) blockSelector = Popup.getPopupSelector(element);

        return $.extend(true, {}, { messageSelector: '.common-ajax-loader', selector: blockSelector }, defaultValue || {});
    }

    function getUiBlockDescriptor(element: HTMLElement, defaultValue: any = undefined) {
        var result = Utils.getObjectByAttributes('block', element, getUiBlockPropertyName, defaultValue);

        return result;
    }

    function needBlock(blockUi) { return (typeof (blockUi) === 'object') && blockUi && (Object.keys(blockUi).length > 0); }

    return {
        unBlock,
        block,
        getDefaultSpinnerBlock,
        getUiBlockDescriptor,
        needBlock
    }
}());